import {Component, PureComponent} from 'react'

export default WrappedComponent => WrappedComponent.prototype && WrappedComponent.prototype.isPureReactComponent ? PureComponent : Component